module.exports = __webpack_public_path__ + "img/FeatureStarUnselected.8de42e12.svg";